import type { Allocations } from './Economy';
import type { RunFlags, RunStats } from './data/types';

const SAVE_KEY = 'the-bottom-line:save:v1';
const SCORES_KEY = 'the-bottom-line:scores:v1';
const BEATEN_KEY = 'the-bottom-line:beaten:v1';

export interface SaveData {
  day: number;
  credits: number;
  alloc: Allocations;
  stats: RunStats;
  flags: RunFlags;
  newGamePlus: boolean;
}

export interface ScoreEntry {
  score: number;
  ending: string;
  when: string;
}

export function saveRun(data: SaveData): void {
  try { localStorage.setItem(SAVE_KEY, JSON.stringify(data)); } catch { /* private mode */ }
}

export function loadRun(): SaveData | null {
  try {
    const raw = localStorage.getItem(SAVE_KEY);
    return raw ? (JSON.parse(raw) as SaveData) : null;
  } catch { return null; }
}

export function clearRun(): void {
  try { localStorage.removeItem(SAVE_KEY); } catch { /* private mode */ }
}

export function submitScore(entry: ScoreEntry): ScoreEntry[] {
  const scores = loadScores();
  scores.push(entry);
  scores.sort((a, b) => b.score - a.score);
  const top = scores.slice(0, 5);
  try { localStorage.setItem(SCORES_KEY, JSON.stringify(top)); } catch { /* private mode */ }
  return top;
}

export function loadScores(): ScoreEntry[] {
  try {
    const raw = localStorage.getItem(SCORES_KEY);
    return raw ? (JSON.parse(raw) as ScoreEntry[]) : [];
  } catch { return []; }
}

export function markBeaten(): void {
  try { localStorage.setItem(BEATEN_KEY, '1'); } catch { /* private mode */ }
}

export function hasBeatenGame(): boolean {
  try { return localStorage.getItem(BEATEN_KEY) === '1'; } catch { return false; }
}
